"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSelect = void 0;
var react_1 = require("react");
var UseSelectUtils_1 = require("./UseSelectUtils");
var useSelect = function (configuration) {
    var _a, _b;
    var _c = react_1.useState(""), query = _c[0], setQuery = _c[1];
    var onInputChange = function (value) {
        if (configuration.disabled) {
            return;
        }
        setQuery(value);
    };
    // Upscale values to array of V
    var values = configuration.value
        ? Array.isArray(configuration.value)
            ? configuration.value
            : [configuration.value]
        : [];
    var constructedOptions = UseSelectUtils_1.constructOptions(
    // only static options are allowed to pass to <Select> and hence useSelect so we
    // cast configuration.options to Options<T,V>. useAsyncSelect understands the promise
    // aspect of configuration.options.
    (_a = configuration.options) !== null && _a !== void 0 ? _a : [], values, configuration.getItemForValue, configuration.autoLabelProperty);
    var filteredOptions = constructedOptions;
    if (configuration.filterInClient && query) {
        if (configuration.filterPredicate) {
            filteredOptions = constructedOptions.filter(function (option) { var _a; return (_a = configuration.filterPredicate) === null || _a === void 0 ? void 0 : _a.call(configuration, option, query); });
        }
        else {
            filteredOptions = constructedOptions.filter(function (option) {
                var _a;
                return "label" in option
                    ? (_a = option.label) === null || _a === void 0 ? void 0 : _a.toString().toLowerCase().includes(query.toLowerCase())
                    : "value" in option && option.value && typeof option.value === "string"
                        ? option.value.toString().toLowerCase().includes(query.toLowerCase())
                        : false;
            });
        }
    }
    var flattenedOptions = UseSelectUtils_1.flattenOptions(filteredOptions);
    var selectedOptions = flattenedOptions.filter((_b = configuration.selectedPredicate) !== null && _b !== void 0 ? _b : (function (option) { return values.some(function (value) { return UseSelectUtils_1.isValueOrItemEqualToOption(option, value); }); }));
    var callOnChange = function (newSelectedOptions) {
        var _a, _b;
        var values = newSelectedOptions.map(function (newSelectedOption) { return newSelectedOption.value; });
        if (configuration.multiple) {
            //@ts-ignore
            (_a = configuration.onChange) === null || _a === void 0 ? void 0 : _a.call(configuration, values, newSelectedOptions);
        }
        else {
            //@ts-ignore
            (_b = configuration.onChange) === null || _b === void 0 ? void 0 : _b.call(configuration, values[0], newSelectedOptions[0]);
        }
    };
    var addValue = function (value) {
        var newValues;
        if (configuration.multiple) {
            newValues = __spreadArray(__spreadArray([], values), [value]);
        }
        else {
            newValues = [value];
        }
        callOnChange(UseSelectUtils_1.constructOptions(newValues, [], configuration.getItemForValue, configuration.autoLabelProperty));
    };
    var onSelectOption = function (option) {
        if (option.disabled || configuration.disabled) {
            return;
        }
        var optionIsSelected = configuration.selectedPredicate
            ? configuration.selectedPredicate(option)
            : selectedOptions.some(function (selectedOption) {
                return UseSelectUtils_1.isValueOrItemEqualToOption(selectedOption, option.value);
            });
        var newSelectedOptions;
        if (optionIsSelected && configuration.multiple) {
            /**
             * In multi-select mode, so deselect the value that was clicked if
             * it's already selected.
             */
            newSelectedOptions = selectedOptions.filter(function (selectedOption) { return selectedOption.value !== option.value; });
        }
        else {
            if (configuration.multiple) {
                newSelectedOptions = __spreadArray(__spreadArray([], selectedOptions), [option]);
            }
            else {
                newSelectedOptions = [option];
            }
            // TODO call onSelect? to close, reset search, refocus,etc.
        }
        callOnChange(newSelectedOptions);
    };
    var activeOptions = flattenedOptions.filter(function (option) { return !option.disabled; });
    var isAllSelected = activeOptions.every(function (option) { return selectedOptions.includes(option); });
    var disabledSelectedOptions = flattenedOptions.filter(function (option) { return option.disabled && selectedOptions.includes(option); });
    var onSelectAll = function () {
        if (isAllSelected) {
            callOnChange(disabledSelectedOptions);
        }
        else {
            callOnChange(activeOptions);
        }
    };
    var onClearSelection = function () {
        callOnChange(disabledSelectedOptions);
    };
    return {
        query: query,
        onInputChange: onInputChange,
        options: filteredOptions,
        selectedOptions: selectedOptions,
        onClearSelection: onClearSelection,
        onSelect: onSelectOption,
        onSelectAll: onSelectAll,
        addValue: addValue,
        activeOptions: activeOptions,
        isAllSelected: isAllSelected,
    };
};
exports.useSelect = useSelect;
//# sourceMappingURL=useSelect.js.map